import { ShelfCell } from './ShelfCell';
import styles from './Shelf.module.css';
import { ShelfHeader } from './ShelfHeader';

interface Props {
    shelf: any;
    selectedLocation: string;
    onSelect: (locationId: string) => void;
}

export const Shelf = ({ shelf, selectedLocation, onSelect }: Props) => {

    let { width, height, shelf: shelfName } = shelf;
    const rows = Array.from({ length: height }, (_, i) => height - i);
    const cols = Array.from({ length: width }, (_, i) => i + 1);
    const hasSpecialPlaces = shelf.shelf.startsWith("D-01") || shelf.shelf.startsWith("D-02") || shelf.shelf.startsWith("D-03") || shelf.shelf.startsWith("D-04");
    return (
        <div>
            {/* <ShelfHeader shelfName={shelfName} /> */}
            <table className={styles.table} data-has-special-places={hasSpecialPlaces}>
                <tbody>
                    {rows.map(y => (
                        <tr key={`row-${y}`}>
                            {cols.map(x => {
                                const locationId = `${shelfName}-${x}/${y}`;
                                const isSelected = selectedLocation === locationId;
                                return <ShelfCell key={`cell-${x}-${y}`} shelfName={shelfName} x={x} y={y} isSelected={isSelected} onSelect={onSelect} />
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}